// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ClosuresExecutiveList    = lazy(() => import('../../views/closures/executive/list'))
const ClosuresExecutiveEdit    = lazy(() => import('../../views/closures/executive/edit'))
const ClosuresExecutivePrint   = lazy(() => import('../../views/closures/executive/print'))
const ClosuresExecutivePreview = lazy(() => import('../../views/closures/executive/preview'))

const ClosuresExecutive = [
  {
    path: '/closures/executive/list',
    element: <ClosuresExecutiveList />
  },
  {
    path: '/closures/executive/edit/:id',
    element: <ClosuresExecutiveEdit />
  },
  {
    path: '/closures/executive/print/:id',
    element: <ClosuresExecutivePrint />,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/closures/executive/preview/:id',
    element: <ClosuresExecutivePreview />
  }
]

export default ClosuresExecutive
